var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5107 5.64036H26.53L22.8145 1.10107H13.8071L10.0916 5.64036H3.11088C2.17813 5.64036 1.422 6.40247 1.422 7.34259V24.3649C1.422 25.305 2.17813 26.0671 3.11088 26.0671H33.5107C34.4435 26.0671 35.1996 25.305 35.1996 24.3649V7.34259C35.1996 6.40247 34.4435 5.64036 33.5107 5.64036Z",
    stroke: "url(#paint0_linear_3957_1877)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3108 22.6629C22.6636 22.6629 26.1923 19.1064 26.1923 14.7191C26.1923 10.3319 22.6636 6.77539 18.3108 6.77539C13.958 6.77539 10.4294 10.3319 10.4294 14.7191C10.4294 19.1064 13.958 22.6629 18.3108 22.6629Z",
    stroke: "url(#paint1_linear_3957_1877)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6957 10.7471C31.0066 10.7471 31.2587 10.4931 31.2587 10.1797C31.2587 9.86634 31.0066 9.6123 30.6957 9.6123C30.3848 9.6123 30.1328 9.86634 30.1328 10.1797C30.1328 10.4931 30.3848 10.7471 30.6957 10.7471Z",
    stroke: "url(#paint2_linear_3957_1877)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3112 18.1234C20.1767 18.1234 21.6889 16.5992 21.6889 14.7189C21.6889 12.8387 20.1767 11.3145 18.3112 11.3145C16.4457 11.3145 14.9334 12.8387 14.9334 14.7189C14.9334 16.5992 16.4457 18.1234 18.3112 18.1234Z",
    stroke: "url(#paint3_linear_3957_1877)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3957_1877",
    x1: 35.1996,
    y1: 1.10107,
    x2: 1.422,
    y2: 1.10107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3957_1877",
    x1: 26.1923,
    y1: 6.77539,
    x2: 10.4294,
    y2: 6.77539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3957_1877",
    x1: 31.2587,
    y1: 9.6123,
    x2: 30.1328,
    y2: 9.6123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3957_1877",
    x1: 21.6889,
    y1: 11.3145,
    x2: 14.9334,
    y2: 11.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E3A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic-camera.187479693f9d2ea112547033c0671c88.svg";
export { ForwardRef as ReactComponent };